import React from 'react';

export default function KpiCell({ label, value, sub, last }) {
  return (
    <div
      className="px-5 py-4"
      style={{
        borderRight: last ? 'none' : '1px solid #F0EFE9'
      }}
    >
      <div className="text-[11px] uppercase tracking-wider" style={{ color: '#9A9A95', letterSpacing: '0.06em' }}>{label}</div>
      <div className="mt-2" style={{ fontSize: 22, fontWeight: 600, color: '#1A1A1A', fontVariantNumeric: 'tabular-nums', lineHeight: 1.1 }}>{value}</div>
      {sub && <div className="mt-1 text-[11px]" style={{ color: '#888' }}>{sub}</div>}
    </div>
  );
}
